import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  FormTextarea,
  Button
} from "shards-react";

const DeveloperDetails = ({ title }) => (
  <Card small className="mb-4">
    <CardHeader className="border-bottom">
      <h6 className="m-0">{title}</h6>
    </CardHeader>
    <ListGroup flush>
      <ListGroupItem className="p-3">
        
      <strong>Hello! 👋 </strong><br></br><br></br>
I’m sure you’ll agree that, at this point, it isn’t an exaggeration to say that we are at war against the coronavirus and that it is a war we must win. <br></br><br></br><strong>COVID-19</strong> or as the plebs call it, the coronavirus has restricted a lot of us to our homes. You can choose to while away your time sleeping; doing nothing or you could utilize this break to ‘Learn’ something new. You know you’ve said this a lot to yourself - “I want to Learn 'X' but I can’t seem to find the time.” This is the time; <strong>Turn Your Self-Isolation into Self-Improvement!</strong>

      </ListGroupItem>
      <ListGroupItem className="p-3">
        
      
      Together we are facing an unprecedented time that is affecting all of our community, our families, and our way of life. As the nation battles to curb the impact of the coronavirus, our one and only responsibility right now is to stay safe and practice social distancing.
      The next few weeks are critical in this battle. I request everyone to stay at home and enjoy good time with family.
      </ListGroupItem>
      <ListGroupItem className="p-3">
      Let's fight with Corona together! 😷 <br></br>
        
          <strong>Stay Home, Stay Safe!</strong>
          <br></br><br></br>
          <span className="text-light text-semibold">With lots of love,</span><br></br>
          <span className="text-light text-semibold">Vinit Shahdeo</span>

      </ListGroupItem>
      
      
    </ListGroup>
  </Card>
);

DeveloperDetails.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string
};

DeveloperDetails.defaultProps = {
  title: "An Open Letter"
};

export default DeveloperDetails;
